import { useProject } from '../../context/ProjectContext';
import { FilterChip, FilterMenuItem, TopicIcon } from './FilterChip';

export function TopicFilter() {
  const { userTopics, topicFilterId, setTopicFilterId } = useProject();

  const selected = userTopics.find((t) => t.id === topicFilterId);
  const label = selected?.name ?? 'همه تاپیک‌ها';
  const isActive = topicFilterId != null;

  if (!userTopics.length) return null;

  return (
    <FilterChip icon={<TopicIcon />} label={label} active={isActive}>
      <FilterMenuItem selected={!topicFilterId} onClick={() => setTopicFilterId(null)}>
        همه تاپیک‌ها
      </FilterMenuItem>
      {userTopics.map((topic) => (
        <FilterMenuItem
          key={topic.id}
          selected={topicFilterId === topic.id}
          onClick={() => setTopicFilterId(topic.id)}
        >
          {topic.name}
        </FilterMenuItem>
      ))}
    </FilterChip>
  );
}
